import React from "react";

export default function Para1(props) {
  return (
    <div
      className="  "
      style={{
        fontSize: "16px",
        lineHeight: "26px",
        color: "#7b7b7b",
        fontWeight: "400",
      }}
    >
      {props.para1}
    </div>
  );
}
